// extracted by mini-css-extract-plugin
export default {"changeLang":"tHvgr","ar":"b0nuO"};